












































































import { Component, Vue, Inject, Watch } from 'vue-property-decorator';
import AnagraficaSearch from '@/components/AnagraficaSearch.vue';
import StpSearch from '@/components/stp/StpSearch.vue';
import StpTable from '@/components/stp/StpTable.vue';
import AnagraficaTable from '@/components/AnagraficaTable.vue';
import { Anagrafica, AnagraficaRequest } from '../models/anagrafica.model';
import { AnagraficaService } from '../services/anagrafica.service';
import { Page } from '../models/page.model';

@Component({
	components: {
		AnagraficaSearch,
		AnagraficaTable,
		StpSearch,
		StpTable
	}
})
export default class AnagraficaList extends Vue {

	@Inject('AnagraficaService')
	anagraficaService!: AnagraficaService;

	data: Anagrafica[] = [];
	loading: boolean = false;

	searchparam: AnagraficaRequest = new AnagraficaRequest();
	page: Page = new Page(20);

	template: string = 'iscritti';

	@Watch('template')
	onDataChange() {
		this.data = [];
		if (this.stpTemplate)
			(this.$refs.stpsearch as StpSearch).search()
		if (this.iscrittiTemplate)
			(this.$refs.iscrittisearch as AnagraficaSearch).search()

	}

	mounted() {
		this.search()
	}

	search() {
		this.loading = true;
		const searchreq = this.anagraficaService.search(this.searchparam, this.page);
		const countreq = this.anagraficaService.searchCount(this.searchparam);
		Promise.all([searchreq, countreq]).then(results => {
			this.data = results[0];
			this.page.setTotal(results[1].cnt);
		}).finally(() => {
			this.loading = false;
		})
	}

	onSearchChange(searchparam: AnagraficaRequest) {
		this.searchparam = searchparam;
		this.search();
	}

	onPageChange(page: number) {
		this.page.setPageNumber(page - 1);
		this.search();
	}

	get iscrittiTemplate() {
		return this.template == 'iscritti'
	}

	get stpTemplate() {
		return this.template == 'stp'
	}
}
